/* eslint-disable no-undef */
;(function () {
  if (!window.wkndContext) return

  function wunderkindSDK (eventName, payload) {
    const sdk = window.wunderkind && window.wunderkind.sdk && window.wunderkind.sdk.events
    if (sdk) {
      if (sdk[eventName]) return sdk[eventName](payload || {})
      return
    }
    try {
      let items = JSON.parse(localStorage.getItem('wknd_web_sdk_preloaded_events')) || []
      if (!Array.isArray(items)) items = []
      items.push({ eventName, payload: payload || {} })
      localStorage.setItem('wknd_web_sdk_preloaded_events', JSON.stringify(items))
    } catch (e) { /* noop */ }
  }

  const ctx = window.wkndContext
  const idSuffix = ctx.idSuffix || ''

  function buildItemId (lineItem) {
    const handle = lineItem.handle || lineItem.product_handle
    if (handle) return handle + idSuffix
    return String(lineItem.product_id)
  }

  function fireAddToCartForItems (items) {
    items.forEach((item) => {
      wunderkindSDK('addToCart', { 'item:id': buildItemId(item) })
    })
  }

  function extractAddedItems (detail) {
    if (!detail) return []
    if (Array.isArray(detail.items)) return detail.items
    if (detail.id && (detail.handle || detail.product_handle || detail.product_id)) return [detail]
    return []
  }

  if (ctx.customer && ctx.customer.email) {
    wunderkindSDK('logIn', { email: ctx.customer.email })
  }

  function fireViewCategory (data) {
    if (!data || !data.itemIds || !data.itemIds.length) return
    wunderkindSDK('viewCategory', {
      'items:ids': data.itemIds,
      'page:url': data.url,
    })
  }

  fireViewCategory(ctx.collection)
  if (ctx.search) {
    fireViewCategory({
      itemIds: ctx.search.itemIds,
      url: window.location.href,
    })
  }

  if (ctx.product) {
    wunderkindSDK('item', {
      id: ctx.product.id,
      copy: ctx.product.copy,
      category: ctx.product.category,
      instock: String(ctx.product.instock),
      imageurl: ctx.product.imageurl,
      url: ctx.product.url,
    })

    wunderkindSDK('viewItem', {
      'item:id': ctx.product.id,
      'item:itemgroupid': String(ctx.product.groupId),
    })

    document.addEventListener('variantChange', (e) => {
      const v = e.detail && e.detail.variant
      if (!v) return
      wunderkindSDK('selectItem', {
        'item:id': ctx.product.id,
        'item:itemgroupid': String(ctx.product.groupId),
        'item:feedid': String(v.id),
      })
    }, true)

    const hasVariantSelector = !!document.querySelector('variant-selects, variant-radios')
    if (!hasVariantSelector) {
      wunderkindSDK('selectItem', {
        'item:id': ctx.product.id,
        'item:itemgroupid': String(ctx.product.groupId),
        'item:feedid': String(ctx.product.feedId),
      })
    }
  }

  let lastItemCount = null
  const cartUrl = `${window.routes?.cart_url || '/cart'}.js`

  fetch(cartUrl)
    .then((response) => response.json())
    .then((cart) => {
      if (typeof cart.item_count === 'number') lastItemCount = cart.item_count
    })
    .catch(() => {})

  window.addEventListener('cart:updated', (e) => {
    const detail = e.detail
    if (!detail) return

    if (typeof detail.item_count === 'number') {
      if (lastItemCount !== null && detail.item_count === 0 && lastItemCount > 0) {
        wunderkindSDK('emptyCart', {})
      } else if (detail.item_count > (lastItemCount ?? 0)) {
        const addedCount = detail.item_count - (lastItemCount ?? 0)
        const items = detail.items || []
        const newItems = items.slice(-addedCount)
        fireAddToCartForItems(newItems.length ? newItems : items.slice(0, 1))
      }
      lastItemCount = detail.item_count
      return
    }

    const addedItems = extractAddedItems(detail)
    if (!addedItems.length) return

    fireAddToCartForItems(addedItems)

    fetch(cartUrl)
      .then((response) => response.json())
      .then((cart) => {
        if (typeof cart.item_count === 'number') lastItemCount = cart.item_count
      })
      .catch(() => {})
  })
})()
